export default {
  reviewCompleteHeader: 'Review and Complete',
  participants: 'Participants',
  enterParticipantInfoText:
    'Please enter the required details to proceed to checkout.',
  purchaser: 'Purchaser',
  firstName: 'First Name',
  lastName: 'Last Name',
  email: 'Email',
  optionalEmail: 'Email: (optional)',
  'phone:': 'Phone',
  participantFieldPlaceholder: 'Add new or select existing participant',
  reservationSummary: 'Reservation Summary',
  editParticipantsDetails: 'Edit Participant Details',
  participantDetails: 'Details',
  duplicatePurchaserText: 'Same as Purchaser',
  phone: 'Phone',
  addParticipant: 'Additional {{tierLabel}}',
  participant: 'Participant',
  removeParticipant: 'Remove',
  experienceCheckoutCompleted: 'Experience Checkout Completed',
  experienceCartCheckout: 'Experience Cart Checkout',
  experienceLimitReached:
    'Sorry, this experience has reached its maximum participant count',
  payment: 'Payment',
  duration: 'Duration',
  discountCode: 'Discount Code',
  removeCode: 'Remove Code',
  invalidCodeValidation: 'Invalid Coupon Code',
  networkErrorDiscountCode: 'Something went wrong on our side',
  onlyOneCouponCodeAllowed: 'Only one coupon code is allowed',
  creditCodeHasAlreadyBeenApplied: 'Credit code has already been applied',
  discount: 'Discount',
  promo: 'Promo',
  promoCode: 'Promo code',
  apply: 'Apply',
  total: 'Total',
  subTotal: 'Subtotal',
  includes: 'Includes',
  and: 'and',
  addHostNotes: 'Add notes for your host',
  brandAggreementText:
    'I agree to, or I otherwise certify that I am authorized on behalf of the participant(s) to agree to, the terms and conditions of the',
  termsAggreementValidation: 'Please agree to the terms',
  firstNameValidation: 'First Name is required',
  lastNameValidation: 'Last Name is required',
  emailValidation: {
    emailRequiredText: 'Email is required',
    invalidEmail: 'Invalid Email Address',
    not_specified: 'Incorrect Email Address',
  },
  phoneValidation: {
    'Invalid Phone Number': 'Invalid Phone Number',
    not_specified: 'Invalid',
    phoneRequiredText: 'Phone number is required',
  },
  participantFirstNameValidation: 'Participant First Name is required',
  participantLastNameValidation: 'Participant Last Name is required',
  complete: 'Complete',
  '404Message': 'Not Found',
  waiting: 'Waiting...',
  complimentary: 'Complimentary',
  salesClosed: 'Sales closed',
  confirmationHeader: 'Your experience has been booked!',
  confirmationText:
    'A confirmation email was sent to {{email}} with additional details',
  viewAll: 'View all Experiences',
  paymentMethod: 'Payment Method',
  creditCard: 'Credit Card',
  roomCharge: 'Room Charge',
  memberCharge: 'Member Charge',
  roomOrReservationNumber: 'Room Number or Confirmation Number',
  roomNumber: 'Room Number',
  roomNumberLegacy: 'Room Number / Confirmation Code',
  memberNumber: 'Member Number',
  kicc: 'Easy Pay',
  chargeValidation: 'Room Number and Last name is required',
  memberNumberValidation: 'Member Number is required',
  invalidRoomNumber: 'Room number is invalid',
  invalidRoomNumberLegacy: 'Room number or confirmation code is invalid',
  invalidMemberNumber: 'Member number is invalid',
  invalidPhoneNumber: 'Phone number is invalid',
  requiredPhoneNumber: 'Phone number is required',
  guestNameIsRequired: 'Guest name is required',
  roomNumberIsRequired: 'Room Number is required',
  roomNumberIsRequiredLegacy: 'Room Number or confirmation Code is required',
  roomOrReservationNumberIsRequired:
    'Room number or confirmation number is required',
  cardNumberIncomplete: 'Card Number Incomplete',
  lastNameValidationError: 'Last name is required',
  isReqd: 'is required',
  reservationCode: 'Reservation/Confirmation Number',
  nonHotelGuest: 'Non Hotel Guest',
  onPropertyGuest: 'On Property Guest',
  preArrivalGuest: 'Pre Arrival Guest',
  cardNumber: 'Card number',
  pmsValidationErrorMessage:
    'Invalid last name or room number or confirmation number',
  pmsDateValidationErrorMessage:
    'Sorry! The experience date does not fall between your arrival and departure date.',
  fullName: 'Full Name',
  checkout: 'Checkout',
  editParticipants: 'Edit Participants',
  private: 'Private',
  browseAllExperieces: 'Browse all experiences',
  payWithCreditCard: 'Pay with Credit Card',
  payWithRoomCharge: 'Pay with Room Charge',
  payWithMemberCharge: 'Pay with Member Charge',
  payWith: 'Pay with',
  bookBulkErrorByCard:
    'There was an issue confirming your booking. Your card was not charged.',
  bookBulkErrorByRoomCharge: 'Invalid last name and room number.',
  bookBulkErrorByMemberCharge: 'Invalid last name and member number.',
  reviewCancellation: 'Review Cancellation',
  selectAReservationToCancel: 'Select a reservation to cancel',
  confirmCancellation: 'Confirm cancellation',
  cancellable: 'Cancellable',
  cancelled: 'Canceled',
  deadlinePassed: 'Deadline passed',
  noCancellations: 'No cancellations',
  reviewReschedule: 'Your reservation',
  selectAReservationToReschedule: 'Select a reservation to reschedule',
  confirmReservation: 'Confirm reservation',
  confirm: 'Confirm',
  selectADateAndTime: 'Select a date and time',
  noOtherSessionsAvailableForThisExperience:
    'There are no other sessions available for this experience.',
  thisReservationCanNoLongerBeRescheduledPleaseEmail:
    'This reservation can no longer be rescheduled. Please email {{brandEmail}}',
  thisReservationCannotBeRescheduled: 'This reservation cannot be rescheduled',
  noTimesAvailable: 'No times available',
  noBookingsAvailable: 'No bookings available',
  youPaid: 'You paid',
  refund: 'Refund',
  yourRefund: 'Your refund',
  yourRefundWillBeProcessedToTheOriginalPayment:
    'Your refund will be processed to the original payment.',
  thisReservationCanNoLongerBeCancelledPleaseEmail:
    'This reservation can no longer be canceled. Please email {{brandEmail}}',
  reservationCancelled: 'Reservation canceled',
  thisReservationCannotBeCancelled: 'This reservation cannot be canceled',
  thisReservationHasAlreadyBeenCancelled:
    'This reservation has already been canceled',
  theHotel: 'the Hotel',
  cancelling: 'Cancelling',
  somethingWentWrong: 'Something went wrong',
  previouslyRefunded: 'Previously refunded',
  remainingBalance: 'Remaining Balance',
  notEnoughPoints: 'Not enough points',
  notEnoughPointsDescription:
    'You do not have enough World of Hyatt Points to complete this purchase.',
  currentPointsBalance: 'Current points balance: {{count, number}}',
  points: 'points',
  pointsWithCount_one: '{{count, number}} point',
  pointsWithCount_other: '{{count, number}} points',
  payWithHyattPoints: 'Pay with Hyatt Points',
  pleaseSignIn: 'Please Sign In',
  worldOfHyattPoints: 'World of Hyatt Points',
  bookBulkErrorByNotEnoughSeats:
    'Not enough seats available for the session. Please try another session instead.',
  phoneNumber: 'Phone number',
  requestToBookConfirmationText: 'A confirmation email was sent to {{email}}',
  reservationRescheduled: 'Reservation rescheduled',
  yourReservationWasRescheduledTo: 'Your reservation was rescheduled to',
  viewExperiences: 'View experiences',
  joinBook: 'Join & Book',
  signInBook: 'Sign in & Book',
  signAndJoin: 'Sign in or Join to Book',
  signAndJoinDescription:
    'World of Hyatt FIND Experiences are exclusive to World of Hyatt members. Sign in or join to book and earn points. Prefer not to join? You can still book non-exclusive experiences by removing the World of Hyatt Experience from your cart.',
  promoOrFind: 'Promo or Find Credit Code',
  hyattTermsAndConditions: 'Terms & Conditions',
  hyattTermsAndConditionsAgreement:
    'By confirming this booking, I am accepting the cancellation policy. I have also read and acknowledge the use of my personal information in accordance with the',
  hyattTermsAndConditionsLink: 'Hyatt Privacy Policies',
  hyattWaiverText:
    'By purchasing this experience, I agree, understand, and acknowledge, both on my own behalf and on behalf of any individual who participates in the experience purchased by me (if any), to the following',
  hyattWaiverLink: 'general waiver',
  priceDisclaimer: 'Includes fees before taxes',
  taxesAndFees: 'Taxes & fees',
  day: 'day',
  days: 'days',
  hour: 'hour',
  hours: 'hours',
  curatedRecommendations: 'Curated recommendations',
  moreExperiencesYouMightLike: 'More experiences you might like',
  similarExperiencesAvailableToBookDirectly:
    'Similar experiences available to book directly',
  experiencesAvailableAroundYourBookingDate:
    'Experiences available around your booking date',
  confirmationEmailSent:
    'We sent your confirmation to {{email}} with more details.',
  youreBooked: "You're booked",
  purchaserInformation: 'Purchaser Information',
  requiredFieldIndicator: '* indicates a required field',
  resourceSelectionTitle: 'Choose your options',
  resourceSelectionDescription: 'Pick an option for each item in your booking.',
  resourceUnitLabel: '{{tierName}} {{number}}',
  selectResourceAttribute: 'Select {{attributeName}}',
  resourceValueSoldOut: '{{label}} (sold out)',
  resourceValueUnavailableWith: '{{label}} (not available with {{picks}})',
  resourceOptionsUnavailable:
    'We could not load the options for this time. Please try again.',
  resourceOptionsRetry: 'Try again',
  changeResourceSelections: 'Change your choices',
};
